import { Theme } from "../../../theme/restyle/theme";
import { ButtonVariant } from "./Button";

/**
 * Get the background color for the loading spinner based on button variant
 */
export const getLoadingSpinnerBG = (
  variant: ButtonVariant
): keyof Theme["colors"] => {
  switch (variant) {
    case "main":
      return "button-main-surface-neutral";
    case "white":
    case "ghost":
      return "button-white-surface-neutral";
    case "danger":
      return "button-danger-surface-neutral";
    case "secondary":
    default:
      return "button-alt-surface-neutral";
  }
};

/**
 * Get the color for the loading spinner based on button variant
 */
export const getLoadingSpinnerColor = (
  variant: ButtonVariant
): keyof Theme["colors"] => {
  switch (variant) {
    case "main":
      return "icon-inverse";
    case "white":
      return "text-secondary";
    case "danger":
      return "button-danger-icon";
    case "secondary":
      return "icon-primary";
    default:
      return "button-alt-icon";
  }
};
